import React from "react";
import { Link } from "react-router-dom";
import OptimizedImage from "./ΟptimizedImage";

// Βοηθητική συνάρτηση για την αφαίρεση των HTML tags
const stripHtml = (html) => {
  if (!html) return '';
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

/**
 * Component για την εμφάνιση της ενότητας Συνεντεύξεων (Interviews).
 * Χρησιμοποιεί διάταξη πλέγματος (grid) για οπτική ποικιλομορφία.
 * @param {object[]} interviews - Λίστα άρθρων (posts) που έχουν φιλτραριστεί ως Συνεντεύξεις.
 */
const InterviewsSection = ({ interviews }) => {
  if (!interviews || interviews.length === 0)
    return (
      <div className="text-center py-5 text-dark">
        Δεν υπάρχουν συνεντεύξεις προς το παρόν.
      </div>
    );

  return (
    <section className="interviews-section bg-gray-100 py-5">
      <div className="container">
        {/* Τίτλος */}
        <h2 className="text-primary fw-bold border-bottom border-2 border-primary d-inline-block mb-4 px-2">
          INTERVIEWS
        </h2>

        {/* Grid για τις Συνεντεύξεις (3 στήλες σε desktop) */}
        <div className="row">
          {interviews.map((article) => (
            <div key={article.id} className="col-md-4 mb-4">
              <div className="card shadow-sm h-100 border-0 rounded-lg overflow-hidden">
                {/* Εικόνα */}
                <Link to={`/articles/${article.id}`}>
                  <OptimizedImage
                    src={article.mainImageUrl || article.image}
                    alt={article.title}
                    className="card-img-top w-100"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                </Link>

                <div className="card-body d-flex flex-column">
                  {/* Τίτλος */}
                  <Link
                    to={`/articles/${article.id}`}
                    className="text-decoration-none"
                  >
                    <h5 className="card-title fw-bold text-dark hover-text-primary">
                      {article.title}
                    </h5>
                  </Link>
                  
                  {/* Περίληψη (Καθαρισμένη από HTML) */}
                  <p className="card-text text-secondary small flex-grow-1">
                    {stripHtml(article.content)?.slice(0, 100)}...
                  </p>

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    {/* Ημερομηνία */}
                    <small className="text-muted">
                      {article.createdAt?.toDate().toLocaleDateString("el-GR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </small>
                    
                    {/* Κατηγορία/Είδος */}
                    <span className="badge bg-dark text-white p-2">
                      {article.genre || article.category}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterviewsSection;
